import React from 'react'
import {
  Button,
  Typography,
  Grid, makeStyles,
  Box,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { Form, Formik } from 'formik'
import { selectorLoading } from '../../../app/slices/loadingSlice'
import {
  confirmSMS, selectRegisterForm, registerUser,
} from '../../../app/slices/userSlice'
import { selectorUserPackage } from '../../../app/slices/packageSlice'
import InputTimer from '../InputTimer'
import BankPortal from '../../../components/bankPortal/BankPortal'
import './ConfirmSms.css'

const CONFIRM_STEPS = {
  SEND_CODE: 'SEND_CODE',
  BANK_PORTAL: 'BANK_PORTAL',
}

const initialValues = {
  code: '',
  discount: '',
}

const validationSchema = (t) => Yup.object().shape({
  code: Yup.string()
    .length(6, t('codeـmustـbeـsix_characters'))
    .required(`${t('code')} ${t('required')}`),
})

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
  },
  titleSection: {
    marginTop: theme.spacing(4),
    width: '100%',
    textAlign: 'center',
  },
  descSection: {
    fontSize: theme.spacing(1.8),
    color: '#acacac',
    width: '100%',
    textAlign: 'center',
    marginTop: theme.spacing(1.5),
    marginBottom: '2vh',
  },
  item: {
    // height: theme.spacing(14),
    padding: theme.spacing(1.5),
    margin: 'auto',
  },
  inputAdornment: {
    paddingRight: 0,
  },
  discountItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    paddingRight: '0 !important',
  },
  discountGroup: {
    // marginTop: theme.spacing(2),
  },
  discount: {
    margin: 0,
  },
  divider: {
    width: '100%',
    marginTop: theme.spacing(2),
  },
  amountFinal: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: '0 !important',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '3rem',
  },
  buttonBack: {
    width: '50%',
    whiteSpace: 'nowrap',
    marginRight: theme.spacing(2),
    borderRadius: '10px',
    height: '60px',
    color: '#ffffff',
    backgroundColor: '#f9b233',
    fontSize: '18px',
    fontWeight: 'bold',
    marginTop: '10%',
    marginBottom: '10%',
  },
  buttonSend: {
    width: '50%',
    whiteSpace: 'nowrap',
    borderRadius: '10px',
    color: '#ffffff',
    backgroundColor: '#f9b233',
    fontSize: '18px',
    height: '60px',
    fontWeight: 'bold',
    marginTop: '10%',
    marginBottom: '10%',
  },
}))

const ConfirmSmsStep = ({
  setActiveStep,
}) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const loading = useSelector(selectorLoading)
  const dispatch = useDispatch()
  // const navigate = useNavigate()
  const [confirmStep, setConfirmStep] = React.useState(CONFIRM_STEPS.SEND_CODE)
  const [finishTime, setFinishTime] = React.useState(false)
  const registerForm = useSelector(selectRegisterForm)
  const pkg = useSelector(selectorUserPackage)?.[0]?.package

  const handleBack = () => {
    setActiveStep(0)
  }

  const handleSubmit = (fields) => {
    const FormData = {
      userName: registerForm?.userName,
      verifyCode: fields.code,
    }
    dispatch(confirmSMS(FormData, () => {
      setConfirmStep(CONFIRM_STEPS.BANK_PORTAL)
    }))

    // setTimeout(() => {
    //   navigate('/app/profile/edit', { replace: true })
    // }, 500)
  }

  const handleResendCode = (callback) => {
    dispatch(registerUser(t, registerForm, callback))
  }

  return confirmStep === CONFIRM_STEPS.SEND_CODE ? (

    <Grid item xs={12} sm={12}>
      <Box className="main_register_confirm_sms">
        <Box
          className="register-image-sms-warp"
          style={{ height: '100%' }}
        >
          <img
            style={{ height: '100%' }}
            src="images/register.png"
            className="new-register-sms-image"
            alt="Login"
          />

        </Box>
        <div style={{ overflowY: 'auto', flexGrow: 1 }}>
          <div className="new_register_confirm_sms_form_section">
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              className="form_register_section_sms"
            >
              <img
                src="images/logo.svg"
                style={{ width: '180px', height: 'auto', margin: '50px auto 120px' }}
                alt="logo"
              />
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema(t)}
                onSubmit={(fields) => handleSubmit(fields)}
                enableReinitialize
              >
                {(formikProps) => {
                  // console.log(CurrentComponent)
                  return (
                    <Form className={classes.form} style={{ width: '100%' }}>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        classes={{ root: classes.root }}
                        style={{ margin: '0 auto 12%' }}
                      >
                        <Typography
                          classes={{ root: classes.titleSection }}
                          variant="h4"
                        >
                          {t('enterـcode_sent')}
                        </Typography>
                        <Typography
                          classes={{ root: classes.descSection }}
                          variant="body1"
                        >
                          {`${t('your_mobile')}: ${registerForm?.profile?.phoneNumber || ''}`}
                        </Typography>
                        <Grid item xs={12} sm={12} md={12} classes={{ root: classes.item }}>
                          <InputTimer
                            {...formikProps}
                            finishTimeState={[finishTime, setFinishTime]}
                            handleResendCode={handleResendCode}
                          />
                        </Grid>
                      </Grid>
                      <Grid classes={{ root: classes.buttonContainer }}>
                        <Button
                          onClick={handleBack}
                          classes={{ root: classes.buttonBack }}
                          variant="contained"
                          color="primary"
                          size="large"
                        >
                          {t('back_level')}
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          classes={{ root: classes.buttonSend }}
                          disabled={!!loading || finishTime}
                          type="submit"
                          size="large"
                        >
                          {t('send')}
                        </Button>
                      </Grid>
                    </Form>
                  )
                }}
              </Formik>
            </Box>
          </div>
        </div>
      </Box>
    </Grid>
  ) : (
    <BankPortal pkg={pkg} />
  )
}

ConfirmSmsStep.label = 'final_approval'

ConfirmSmsStep.propTypes = {
  setActiveStep: PropTypes.func,
}
export default ConfirmSmsStep
